export default __webpack_public_path__ + "static/media/approved.4fe8f569.svg";